/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import InsticatorLogo from 'components/shared/logo/insticator/insticator';



/* ========== ~~~~~~~~~~ LOGO : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentData, contentStatus, settings, queueStatus, embedSettings }, { contentId }) => ({
    frameData: !!contentId ? contentData[contentId].data[contentStatus[contentId].frame] : null,
    currentContentStatus: !!contentId ? contentStatus[contentId] : null,
    currentContentSettings: !!contentId ? settings.contentSettings[contentId] : null,
    siteURL: !!settings.embedSettings ? settings.embedSettings.site.url : "",
    enableInsticatorBranding: settings.embedSettings.enableInsticatorBranding,
    contentId,
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
  mapStateToProps
)(InsticatorLogo);
